import RenderHTML from '@/components/RenderHTML';

interface HtmlContentFieldProps {
  body: string;
}

// Display-only content — no answer to collect, so no label/error/onChange.
const HtmlContentField = ({ body }: HtmlContentFieldProps) => <RenderHTML html={body} />;

export default HtmlContentField;
